"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
const i0 = require("@angular/core");
const i1 = require("../../../projects/angular-sdk/src/4d-mapper.service");
const i2 = require("../service/map-viewer.service");
const i3 = require("../xs/services/events/application-events.service");
DEBUG_1.DEBUG.open('/app/main.service.ts');
const rxjs_1 = require("rxjs");
const _4d_mapper_1 = require("4d-mapper");
const map_viewer_service_1 = require("../service/map-viewer.service");
const identify_interface_1 = require("../xs/interfaces/identify.interface");
const application_events_service_1 = require("../xs/services/events/application-events.service");
class MainService {
    constructor(fourD, cesiumMap, applicationEvents) {
        this.fourD = fourD;
        this.cesiumMap = cesiumMap;
        this.applicationEvents = applicationEvents;
        this.__ID = null;
        this.searchFilesFolder = new rxjs_1.Subject();
        this.searchFilesFolderWithoutGlobal = new rxjs_1.Subject();
        this.newProjectCreatedSubject = new rxjs_1.Subject();
        this.createNewFolder = new rxjs_1.Subject();
        // openGoogleDriveSub: Subject<any> = new Subject<any>();
        this.openDropBoxSub = new rxjs_1.Subject();
        this.uploadFilesSub = new rxjs_1.Subject();
        this.dropFilesSub = new rxjs_1.Subject();
        this.renameSub = new rxjs_1.Subject();
        this.moveFolderSub = new rxjs_1.Subject();
        this.folderDeleteSub = new rxjs_1.Subject();
        this.startAdHocFolderSub = new rxjs_1.Subject();
        this.uploadExistingFiles = new rxjs_1.Subject();
        DEBUG_1.DEBUG.log('/app/main.service.ts', 'CONSTRUCTOR', [fourD, cesiumMap]);
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
    }
    newFolder(parent) {
        this.createNewFolder.next(parent);
    }
    /*
      openGoogleDrive() {
        this.openGoogleDriveSub.next();
      }
      openDropBox(){
        this.openDropBoxSub.next();
      }*/
    uploadFiles(e) {
        this.uploadFilesSub.next(e);
    }
    dropFile(e) {
        this.dropFilesSub.next(e);
    }
    rename(f) {
        this.renameSub.next(f);
    }
    moveFolder(f) {
        this.moveFolderSub.next(f);
    }
    folderDelete(f) {
        this.folderDeleteSub.next(f);
    }
    startAdHocFolder(f, xform) {
        this.startAdHocFolderSub.next({
            folder: f,
            transformType: xform
        });
    }
    pickDropbox() {
        var options = {
            // Required. Called when a user selects an item in the Chooser.
            success: (files) => {
                if (files && files.length > 0) {
                    files.forEach(file => this.openDropBoxSub.next(file));
                }
            },
            cancel: function () {
            },
            linkType: 'preview',
            multiselect: false,
            folderselect: true,
        };
        Dropbox.choose(options);
    }
}
MainService.GOOGLE_DRIVE = "GOOGLE DRIVE";
MainService.DROPBOX = "DROPBOX";
MainService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MainService_Factory() { return new MainService(i0.ɵɵinject(i1.FourDService), i0.ɵɵinject(i2.CesiumMapService), i0.ɵɵinject(i3.XsApplicationEventsService)); }, token: MainService, providedIn: "root" });
exports.MainService = MainService;
